import CircularProgress from "@material-ui/core/CircularProgress"
import Grid from "@material-ui/core/Grid"
import TextField from "@material-ui/core/TextField"
import Autocomplete from "@material-ui/lab/Autocomplete"
import React from 'react'

function AddPortsModal(props) {

    const {
        selectedOperation = {},
        delayPortsSearch = () => { },
        onSelectPortsOfOperation = () => { },
        portOptions = [],
        portLoading = false,
        onClickCalculateDistance = () => { }
    } = props;

    let newPortOptions = [...portOptions]
    let selectedPort = { label: '', value: '' }
    if (selectedOperation.port) {
        // newPortOptions = [...portOptions, { label: selectedOperation.port, value: selectedOperation.port }]
        selectedPort = { label: selectedOperation.port, value: selectedOperation.port }
    }

    return (
        <div className="add-ports-modal-container">
            <style>{`
                .add-ports-modal-container .MuiAutocomplete-root {
                    width: 100%;
                }
                .add-ports-modal-container .MuiOutlinedInput-root {
                    height: 26px !important;
                    min-height: 26px !important;
                    padding: 0 26px 0 6px !important;
                    font-size: 11px !important;
                    border-radius: 2px !important;
                    background-color: #ffffff !important;
                }
                .add-ports-modal-container .MuiOutlinedInput-notchedOutline {
                    border-color: #cbd5e1 !important;
                }
                .add-ports-modal-container .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
                    border-color: #94a3b8 !important;
                }
                .add-ports-modal-container .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
                    border-color: #d97706 !important;
                    border-width: 1.5px !important;
                }
                .add-ports-modal-container .MuiOutlinedInput-input {
                    padding: 0 !important;
                    font-size: 11px !important;
                    font-weight: 500 !important;
                    height: 26px !important;
                    line-height: 26px !important;
                    box-sizing: border-box !important;
                    color: #000000 !important;
                }
                .add-ports-modal-container .MuiAutocomplete-endAdornment {
                    top: 50% !important;
                    transform: translateY(-50%) !important;
                    right: 4px !important;
                }
                .add-ports-modal-container .MuiIconButton-root {
                    padding: 2px !important;
                }
                .add-ports-modal-container .MuiSvgIcon-root {
                    font-size: 16px !important;
                    color: #475569 !important;
                }
                .add-ports-modal-container .calculate-port-distance-btn {
                    margin: 10px auto 0 auto !important;
                    height: 25px !important;
                    line-height: 25px !important;
                    padding: 0 14px !important;
                    font-size: 11px !important;
                    font-weight: 500 !important;
                    border-radius: 2px !important;
                    background-color: #313C4C !important;
                    color: #ffffff !important;
                    border: none !important;
                    cursor: pointer !important;
                    outline: none !important;
                    display: block !important;
                    transition: background-color 0.15s ease !important;
                }
                .add-ports-modal-container .calculate-port-distance-btn:hover {
                    background-color: #1e293b !important;
                }
                .compact-port-popper .MuiAutocomplete-paper {
                    margin-top: 2px !important;
                    border: 1px solid #cbd5e1 !important;
                    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1) !important;
                    border-radius: 2px !important;
                }
                .compact-port-popper .MuiAutocomplete-option {
                    font-size: 11px !important;
                    min-height: 24px !important;
                    padding: 3px 8px !important;
                    color: #000000 !important;
                    font-weight: 500 !important;
                }
            `}</style>
            <Grid container>
                <Grid item xs={12}>
                    <Autocomplete
                        classes={{ popper: "compact-port-popper" }}
                        options={newPortOptions}
                        value={selectedPort}
                        disableClearable
                        getOptionLabel={(option) => option.label || ""}
                        onChange={(_e, value) => onSelectPortsOfOperation(value)}
                        getOptionSelected={(option, value) => option.value === value.value}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="outlined"
                                placeholder="Search ports"
                                value={selectedPort.label}
                                onChange={e => delayPortsSearch(selectedOperation, e.target.value)}
                                size="small"
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <React.Fragment>
                                            {portLoading ? <CircularProgress color="inherit" size={12} /> : null}
                                            {params.InputProps.endAdornment}
                                        </React.Fragment>
                                    ),
                                }}
                            />
                        )}
                    />
                </Grid>

                <Grid item xs={12}>
                    <button className="calculate-port-distance-btn" onClick={onClickCalculateDistance}>
                        Calculate Port Distance
                    </button>
                </Grid>
            </Grid>
        </div>
    )
}

export default AddPortsModal
